import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Participant } from 'livekit-client';
import type { FloatActiveSpeakerButtonProps } from './FloatActiveSpeakerButton';
import type { FloatActiveSpeakerWindowProps } from './FloatActiveSpeakerWindow';

interface Props {
    participant: Participant;
    className?: string;
    openButtonHidden?: boolean;

    ButtonComponent: React.FC<FloatActiveSpeakerButtonProps>;
    WindowComponent: React.FC<FloatActiveSpeakerWindowProps>;
}

export const FloatActiveSpeaker: React.FC<Props> = ({
    participant,
    className,
    openButtonHidden,
    ButtonComponent,
    WindowComponent,
}) => {
    const { t } = useTranslation();
    const [isOpened, setIsOpened] = useState(false);

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpened(!isOpened);
        },
        [isOpened],
    );

    if (isOpened) {
        return <WindowComponent participant={participant} className={className} onClick={handleClick} />;
    }

    return (
        <ButtonComponent
            tooltip={t('web_screen_sharing_expand_speaker')}
            onClick={handleClick}
            hidden={openButtonHidden}
        />
    );
};
